export default __webpack_public_path__ + "static/media/intro_05.29f1e8e1.png";